import { AddDeviceInput } from "../../API";
import { TemplateDevice } from "../../pages/devices/components/CreateDevicesFromTemplateDialog";

export enum DeviceTypeEnum {
  CH4 = "CC CH4",
  FB4 = "CC FB4",
  FB4_THERMAL = "CC FB4 Thermal",
  V1 = "V1",
}
interface SelectedLocation {
  value: string;
  title: string;
}

interface SelectedNode {
  nodeId: string;
  nodeName: string;
  nodeIP: string;
}

interface MapTemplateOptions {
  templateData: TemplateDevice[];
  selectedCustomerId: string;
  selectedLocation: SelectedLocation | null;
  selectedNodes: SelectedNode[];
  devicePassword: string;
}

export const mapTemplateDataToDeviceInput = ({
  templateData,
  selectedCustomerId,
  selectedLocation,
  selectedNodes,
  devicePassword,
}: MapTemplateOptions): AddDeviceInput[] => {
  const devices: AddDeviceInput[] = [];
  let ogiCount = 1;
  let v1Count = 1;
  let fb4Count = 1;
  let fb4RTSPCount = 1;
  let fb4ThermalCount = 1;
  let fb4ThermalRTSPCount = 1;

  templateData.forEach(template => {
    const { deviceType, deviceIp, nodeNumber } = template;

    const locationTitle = selectedLocation?.title?.replace(/\s+/g, "") || "";
    const locationId = selectedLocation?.value ?? "";

    const selectedNode = selectedNodes[nodeNumber - 1];
    const nodeId = selectedNode?.nodeId.replaceAll("_", "#") ?? "";
    const nodeName = selectedNode?.nodeName ?? "";
    const nodeIp = selectedNode?.nodeIP ?? "";

    const baseDevice = {
      customerId: selectedCustomerId,
      locationId,
      locationName: selectedLocation?.title,
      nodeId,
      nodeName,
      makeModelId: deviceType,
      cameraIpAddress: deviceIp,
    };

    const ch4SourceVideo = `rtsp://${devicePassword}@${deviceIp}/live1`;
    const v1SourceVideo = `rtsp://${deviceIp}:554/live?channel=0&subtype=0`;
    const fb4SourceVideo = `rtsp://${devicePassword}@${deviceIp}/cam/realmonitor?channel=1&subtype=1`;
    const fb4ThermSourceVideo = `rtsp://${devicePassword}@${deviceIp}/cam/realmonitor?channel=2&subtype=1`;

    if (deviceType === DeviceTypeEnum.CH4) {
      devices.push({
        ...baseDevice,
        name: `${locationTitle}-ch4-${ogiCount++}`,
        deviceData: JSON.stringify({
          hasPanTilt: true,
          panTiltIP: deviceIp,
          recentFrame: "",
          keyFrame: "",
          rtspHost: `rtsp://${nodeIp}/${locationTitle}-ch4`,
          sourceVideo: ch4SourceVideo,
          hasZoom: true,
          protocol: "",
          hasRecordVideo: true,
        }),
      });
    } else if (deviceType === DeviceTypeEnum.V1) {
      devices.push({
        ...baseDevice,
        name: `${locationTitle}-multi-${v1Count++}`,
        deviceData: JSON.stringify({
          hasPanTilt: true,
          panTiltIP: deviceIp,
          recentFrame: "",
          keyFrame: "",
          rtspHost: `rtsp://${nodeIp}/${locationTitle}-multi`,
          sourceVideo: v1SourceVideo,
          hasZoom: true,
          protocol: "",
          hasRecordVideo: true,
        }),
      });
    } else if (deviceType === DeviceTypeEnum.FB4) {
      devices.push({
        ...baseDevice,
        name: `${locationTitle}-fb4-${fb4Count++}`,
        deviceData: JSON.stringify({
          hasPanTilt: false,
          panTiltIP: "",
          recentFrame: "",
          keyFrame: "",
          rtspHost: `rtsp://${nodeIp}/${locationTitle}-fb4-${fb4RTSPCount++}`,
          sourceVideo: fb4SourceVideo,
          hasZoom: false,
          protocol: "",
          hasRecordVideo: true,
        }),
      });
    } else if (deviceType === DeviceTypeEnum.FB4_THERMAL) {
      devices.push({
        ...baseDevice,
        name: `${locationTitle}-fb4therm-${fb4ThermalCount++}`,
        deviceData: JSON.stringify({
          hasPanTilt: false,
          panTiltIP: "",
          recentFrame: "",
          keyFrame: "",
          rtspHost: `rtsp://${nodeIp}/${locationTitle}-fb4therm-${fb4ThermalRTSPCount++}`,
          sourceVideo: fb4ThermSourceVideo,
          hasZoom: false,
          protocol: "",
          hasRecordVideo: true,
        }),
      });
    } else {
      const lowercaseDeviceName = deviceType.toLowerCase().replace(/\s+/g, "");

      devices.push({
        ...baseDevice,
        name: `${locationTitle}-${lowercaseDeviceName}`,
        deviceData: JSON.stringify({}),
      });
    }
  });

  return devices;
};
